<template>
  <b-row>
    <b-col md="12">
      <div class="sub-header">{{ label }}</div>
    </b-col>
    <b-col md="12">
      <div class="float-left">
        <a v-if="label === 'Link'" :href="value" target="_blank">{{ value }}</a>
        <span v-else>{{ value ? value : '-' }}</span>
      </div>
    </b-col>
  </b-row>
</template>
<script>
export default {
  name: 'CompetitionDetailRow',
  props: ['label', 'value']
}
</script>
<style scoped>
.sub-header {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: black;
  float: left;
}
a {
  color: #00903c;
}
.row {
  margin-top: 20px;
}
</style>
